import axios from 'axios'
import { BASE_URL, SOCKET_URL } from '../../constants/urls'

/**
 * Get api with filter queries
 * @param {Object} params
 * @param {string} path
 * @returns {Promise}
 */
const filterFetch = (params, path) => {
	return axios.get(BASE_URL + path, {
		params,
	})
}

/**
 * Get api
 * @param {string} path
 * @returns {Promise}
 */
const normalFetch = (path) => {
	return axios.get(BASE_URL + path)
}

const getPing = () => {
	return axios.get(SOCKET_URL + 'ping')
}

const pureFetch = (url) => {
	return axios.get(url, {
		headers: {
			Accept: 'image/*',
		},
		responseType: 'arraybuffer',
	})
}

export { filterFetch, normalFetch, pureFetch, getPing }
